// extracted by mini-css-extract-plugin
export var counter = "new-year-countdown-module--counter--8f8bf";
export var counterItem = "new-year-countdown-module--counter-item--5dffd";
export var counterLabel = "new-year-countdown-module--counter-label--f6df4";
export var counterNumber = "new-year-countdown-module--counter-number--ee088";
export var large = "new-year-countdown-module--large--db189";
export var small = "new-year-countdown-module--small--5add6";